import React from 'react'
import { queryClient as qc } from 'keys'
import { getCorrectWordPerMinuteDoughnutChart, getFactoredPercentAccuracyDoughnutChart, getFluencyDoughnutChart, getFluencyReadingDoughnutChart, getPercentAccuracyDoughnutChart } from 'store/middlewares/assessment.crud'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import DoughnutCharts from './DoughnutCharts'

const DoughnutChartsPage = (props) => {
    const { assessmentFilters } = props
    const { headerFilters } = useSelector(state => state.header)
    const { testTaker } = useSelector(state => state.testTaker)

    const fluencyDoughnut = useQuery({
        queryKey: [qc.fluencyDoughnut, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getFluencyDoughnutChart({ assessmentFilters, headerFilters, testTaker })
            return data
        },
        refetchOnWindowFocus: false,
    })
    const percentAccuracyDoughnut = useQuery({
        queryKey: [qc.percentAccuracyDoughnutChart, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getPercentAccuracyDoughnutChart({ assessmentFilters, headerFilters, testTaker  })
            return data
        },
        refetchOnWindowFocus: false,
    })
    const factoredPercentAccuracyDoughnut = useQuery({
        queryKey: [qc.factoredPercentAccuracyDoughnut, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getFactoredPercentAccuracyDoughnutChart({ assessmentFilters, headerFilters, testTaker  })
            return data
        },
        refetchOnWindowFocus: false,
    })
    const fluencyReadingDoughnut = useQuery({
        queryKey: [qc.fluencyReadingDoughnut, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getFluencyReadingDoughnutChart({ assessmentFilters, headerFilters, testTaker  })
            return data
        },
        refetchOnWindowFocus: false,
    })
    const correctWordsPerMinuteDoughnut = useQuery({
        queryKey: [qc.correctWordsPerMinuteDoughnut, headerFilters, testTaker],
        queryFn: async () => {
            const { data } = await getCorrectWordPerMinuteDoughnutChart({ assessmentFilters, headerFilters, testTaker  })
            return data
        },
        refetchOnWindowFocus: false,
    })

    const commonState = {
        fluencyDoughnut,
        percentAccuracyDoughnut,
        factoredPercentAccuracyDoughnut,
        fluencyReadingDoughnut,
        correctWordsPerMinuteDoughnut
    }

    return (
        <DoughnutChartsContext.Provider value={commonState}>
            <DoughnutCharts />
        </DoughnutChartsContext.Provider>
    )
}

export const DoughnutChartsContext = React.createContext()
export default DoughnutChartsPage